import { FormControl, FormGroup } from '@angular/forms';
import { Component, Inject, forwardRef, OnInit, Input, OnDestroy, Optional } from '@angular/core';
import { BaseWidget, NgAisInstantSearch, NgAisIndex } from 'angular-instantsearch';
import { connectAutocomplete } from 'instantsearch.js/es/connectors';
import { HOSPITAL_STATIC_OPTIONS } from '../../objects/algoliaStaticOptions';
import { DOCUMENT } from '@angular/common';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
  selector: 'app-algolia-hospital',
  templateUrl: './algolia-hospital.component.html',
  styleUrls: ['./algolia-hospital.component.scss']
})
export class AlgoliaHospitalComponent extends BaseWidget implements OnInit, OnDestroy {

  declare state: {
    query: string;
    refine: Function;
    indices: object[];
  };
  arrowKeysCode = [37, 38, 39, 40];
  hospitalStaticOptions = HOSPITAL_STATIC_OPTIONS;
  @Input() placeholder: string;
  @Input() public control: FormControl;
  @Input() public group: FormGroup; /**Form group of the input */
  @Input() type: string;
  @Input() label: string;
  @Input() appearance: MatFormFieldAppearance = 'legacy';
  @Input() showError = true;
  @Input() info;

  constructor(
    @Inject(forwardRef(() => NgAisIndex))
    @Optional()
    public parentIndex: NgAisIndex,
    @Inject(forwardRef(() => NgAisInstantSearch))
    public instantSearchInstance: NgAisInstantSearch,
    @Inject(DOCUMENT) private document: any
  ) {
    super('AutocompleteComponent');
  }

  public handleChange($event: KeyboardEvent) {
    if (!this.arrowKeysCode.includes($event.which)) { // To allow arrow key navigation
      const searchText = ($event.target as HTMLInputElement).value;
      this.state.refine(searchText);
      if (typeof this.control.value !== 'object' && this.showError) {
        this.control.setErrors({ 'notFromList': true });
      }
    }
  }

  public ngOnInit() {
    this.createWidget(connectAutocomplete, {});
    super.ngOnInit();
    if (typeof document !== 'undefined') {
      this.document.body.classList.add('hospital-saf');
    }
  }

  displayFn(data: any): string {
    return data && data.full_name ? data.full_name : '';
  }

  onSelect(option) {
    this.control.setErrors(null);
  }
  ngOnDestroy() {
    if (typeof document !== 'undefined') {
      this.document.body.classList.remove('hospital-saf');
    }
  }


}
